const baseFontSize = 16;

/**
 * Defines font sizes and conversion functions for rems
 */
export const sizes = {
  toRem: (sizeInPixels: number) => `${sizeInPixels / baseFontSize}rem`,
};
